module.exports = __webpack_public_path__ + "img/118.ef777988.jpg";